import React from "react";

import AppIcon from "./AppIcon";
import BasicToolTip from "../../tooltips/Tooltip";

const AppIconWithTooltip = ({imageUrl, className, appName} : {imageUrl?: string, className?: string, appName?: string}) => {   
    if (!appName) {
        return <AppIcon imageUrl={imageUrl} />
    }
    
    return (
        <div className={`app-icon-tooltip-wrapper ${className ?? ""}`} aria-hidden="true">
            <BasicToolTip text={appName}>
                <AppIcon imageUrl={imageUrl} appName={appName}/>
            </BasicToolTip>
        </div>
    );
};

export default AppIconWithTooltip;